import { Component, input, Input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DecimalPipe, NgClass, SlicePipe } from '@angular/common';

import {
  NgbCollapseModule,
  NgbPopoverModule,
  NgbTimepickerModule,
} from '@ng-bootstrap/ng-bootstrap';
import {
  NgMultiLabelTemplateDirective,
  NgSelectModule,
} from '@ng-select/ng-select';
import { Observable } from 'rxjs';
import { plainToClass } from 'class-transformer';

import { MatchModel, TimeMatch } from '@admin/models/Match.model';
import { FormComponent } from '@shared/components';
import { SimpleNameElement } from '@shared/models/SimpleNameElement.model';
import { TimeControllerComponent } from '../time-controller/time-controller.component';
import { MediaEditComponent } from '../media-edit/media-edit.component';
import { CustomDatePickerComponent } from '../custom-date-picker/custom-date-picker.component';
import { CustomInputNumberComponent } from '../custom-input-number/custom-input-number.component';

class Item {
  id: number = -1;
  name: string = '';
  disabled: boolean = false;
}

@Component({
  selector: 'app-campaign-time-controller',
  imports: [
    FormsModule,
    NgClass,
    DecimalPipe,
    SlicePipe,
    NgSelectModule,
    NgbPopoverModule,
    NgbCollapseModule,
    NgbTimepickerModule,
    NgMultiLabelTemplateDirective,
    TimeControllerComponent,
    CustomDatePickerComponent,
    CustomInputNumberComponent,
    MediaEditComponent,
  ],
  templateUrl: './campaign-time-controller.component.html',
  styleUrl: './campaign-time-controller.component.scss',
})
export class CampaignTimeControllerComponent extends FormComponent {
  @Input() override data: MatchModel = new MatchModel();
  viewership = input<string>();

  onChange = output<void>();
  onMedia = output<any[]>();
  onDelete = output<void>();

  broadcasts: SimpleNameElement[] = [];
  channels: SimpleNameElement[] = [];
  collapsed: boolean = false;
  media: any[] = [];
  minutes: number[] = Array.from({ length: 131 }, (_, i) => i);
  seconds: number[] = Array.from({ length: 61 }, (_, i) => i);

  // ! TODO: Fetch from service
  teams: Item[] = [];
  filteredTeams: Item[] = [];
  title = signal<string>('');
  // ! TODO: Fetch from service

  override services: Observable<any>[] = [];

  ngOnInit(): void {
    this.data.firstTimes = this.data.firstTimes.map((timeMatch: any) => {
      return plainToClass(TimeMatch, timeMatch);
    });

    this.data.secondTimes = this.data.secondTimes.map((timeMatch: any) => {
      return plainToClass(TimeMatch, timeMatch);
    });

    if (this.data.broadcast && typeof this.data.broadcast === 'number') {
      this.data.broadcast = [this.data.broadcast];
    }

    this.calculateTimeContracted();
    this.calculateTotalImpressions();
    this.calculateUnits();

    this.services.push(this.api.call(`admin/channels?limit=1000`));
    this.services.push(this.api.call(`admin/catalogs/teams`));

    console.log(this.data);

    this.loadServices();
  }

  handleTeamChange(away: boolean = false) {
    this.filteredTeams = this.teams.map((team) => {
      team.disabled =
        team.id === Number(away ? this.data.away : this.data.home);

      return team;
    });

    const homeTeam = this.teams.find(
      (team) => team.id === Number(this.data.home)
    );
    const awayTeam = this.teams.find(
      (team) => team.id === Number(this.data.away)
    );

    this.title.set((homeTeam?.name || '') + ' vs ' + (awayTeam?.name || ''));
  }

  handleBroadcastChange() {
    this.data.broadcast = this.broadcasts.map((channel: any) => channel.id);
  }

  handleSelectMedia(media: any, index: number) {
    this.media[index] = media;

    this.onMedia.emit(this.media);
  }

  override onLoadServicesSuccess(responses: any[]): void {
    if (responses[0].status === 200 && responses[0].data.rows) {
      this.channels = responses[0].data.rows;
    }

    this.broadcasts = this.channels.filter((channel: any) => {
      return this.data.broadcast.includes(channel.id);
    });

    if (responses[1].status === 200 && responses[1].data) {
      this.teams = responses[1].data?.map((team: any) => {
        return plainToClass(Item, team);
      });

      this.filteredTeams = [...this.teams];

      this.handleTeamChange();
    }

    super.onLoadServicesSuccess(responses);
  }

  deleteMatch() {
    this.onDelete.emit();
  }

  calculateUnits() {
    this.data.timeContracted.setTime(this.data.unitsContracted * 30);
  }

  calculateTotalImpressions() {
    this.data.impressions = this.data.viewership * this.data.unitsDelivered;
    this.data.impressions = parseFloat(this.data.impressions.toFixed(2));
    this.onChange.emit();
  }

  calculateTimeContracted() {
    // ! DEFINED ON FORMULA
    const DIVIDER = 30;

    this.data.timeDelivered.setTime(
      this.data.totalFirst.totalTime() + this.data.totalSecond.totalTime()
    );

    this.data.unitsDelivered = this.data.timeDelivered.totalTime() / DIVIDER;
    this.calculateTotalImpressions();

    this.onChange.emit();
  }
}
